/**
 * @file paddle page hooks
 * @author wanzhongyun
 */

import { useEffect, useState } from 'react';
import { getCmsDataInfo } from './../../api/pages/paddleCmsGetDataApi';
import useQuickStartStore from './components/quick-start/quickStartHooks';
import { getOsType } from './../../utils/osType';
import { 
    IInterBanner,
    IInterFeatures,
    IQuickInstall,
    IinterOnlineExp,
    IinterMLProject,
    IinterProducts,
    IinterSupport,
    IinterPower,
    IinterImpact
} from './types';

const useIndex = () => {
    const quickStartHooks = useQuickStartStore();
    const {setQuickInstallSelector, setQuickInstallList} = quickStartHooks;
    const setQuickInstallChecked = quickStartHooks.setChecked;
    const setQuickInstallSuffixText = quickStartHooks.setSuffixText;
    const [quickInstall, setQuickInstall] = useState<IQuickInstall>();
    const [interBanner, setInterBanner] = useState<IInterBanner>({
        "title": '',
        "desc": '',
        "btnWord": '',
        "btnLink": ''
    });

    const [interFeatures, setInterFeatures] = useState<IInterFeatures>({
        title: '',
        desc: '',
        list: []
    });

    const [interOnlineExp, setInterOnlineExp] = useState<IinterOnlineExp>({
        title: '',
        desc: '',
        list: []
    });

    const [interMLProject, setInterMLProject] = useState<IinterMLProject>({
        title: '',
        desc: '',
        list: []
    });

    const [interProducts, setInterProducts] = useState<IinterProducts>({
        title: '',
        desc: '',
        list: []
    });

    const [interSupport, setInterSupport] = useState<IinterSupport>({
        title: '',
        desc: '',
        title1: '',
        desc1: '',
        list: []
    });

    const [interPower, setInterPower] = useState<IinterPower>({
        title: '',
        desc: '',
        list: []
    });

    const [interImpact, setInterImpact] = useState<IinterImpact>({
        title: '',
        desc: '',
        allLink: '',
        indexList: [],
        logoList: []
    });
    
    useEffect(() => {
        (async() => {
            const res = await getCmsDataInfo({requestUrl: '/paddleInterPage'});
            if (res) {

                const data = res.body.result?.pageData || {};
                data.interBanner && setInterBanner(data.interBanner);
                data.interFeatures && setInterFeatures(data.interFeatures);
                data.interOnlineExp && setInterOnlineExp(data.interOnlineExp);
                data.interMLProject && setInterMLProject(data.interMLProject);
                data.interProducts && setInterProducts(data.interProducts);
                data.interSupport && setInterSupport(data.interSupport);
                data.interPower && setInterPower(data.interPower);
                data.interImpact && setInterImpact(data.interImpact);

                const qi: any = data.quickInstall || {};
                const qiGroup: any[] = Array.isArray(qi.group) ? qi.group : [];
                const qiList: any[] = Array.isArray(qi.list) ? qi.list : [];
                setQuickInstall({
                    title: qi.title,
                    subtitle: qi.subtitle
                });
                const resQiGroup = qiGroup.map(groupItem => {
                    const list: any[] = Array.isArray(groupItem.list) ? groupItem.list : [];
                    return {
                        groupName: groupItem.groupName,
                        groupKey: groupItem.groupKey || groupItem.groupName,
                        disabledTooltip: groupItem.disabledTooltip,
                        tips: groupItem.tips,
                        list: list.map(item => ({
                            id: `${groupItem.groupName}${item.optionName}${item.optionKey}`,
                            groupName: groupItem.groupName,
                            groupKey: groupItem.groupKey || groupItem.groupName,
                            optionName: item.optionName,
                            optionKey: item.optionKey
                        }))
                    };
                });
                setQuickInstallSelector(resQiGroup);
                const resQIList = qiList.map(item => {
                    const context: any[] = Array.isArray(item.context) ? item.context : [];
                    return {
                        index: item.index,
                        indexSet: typeof (item.index) === 'string' ? new Set<string>(item.index.split(',')) : new Set<string>(),
                        context: context.map(contextItem => ({
                            title: contextItem.title,
                            text: contextItem.text
                        }))
                    };
                });
                setQuickInstallList(resQIList);

                setQuickInstallSuffixText(qi.suffixText || '');

                // 设置快速安装默认选中的项目
                const currentOs = getOsType();
                
                const defaultOs = (() => {
                    if (currentOs === 'macos') {
                        return ((qi.defaultSelectedKey as string).replace(/cuda102/, 'cpu').replace(/linux/, 'macos'))
                    }
                    if (currentOs === 'windows') {
                        return ((qi.defaultSelectedKey as string).replace(/linux/, 'windows'));
                    }
                    return '';
                })();
                const qiDefaultCheckedStr = defaultOs || qi.defaultSelectedKey || '';
                const qiDefaultChecked = qiDefaultCheckedStr.split(',');
                
                // 剔除列表中没有但是默认选中里有的key值
                const existKey = new Set();
                resQiGroup.forEach((group) => {
                    group.list.forEach((item) => {
                        existKey.add(item.optionKey);
                    });
                });
                setQuickInstallChecked((old) => {
                    const def = old.filter(k => existKey.has(k));
                    return (
                        old.length > 0 ? def : qiDefaultChecked
                    );
                });
            }
        })()
    }, [setQuickInstallList, setQuickInstallSelector, setQuickInstallChecked, setQuickInstallSuffixText]);
    return {
        interBanner,
        interFeatures,
        quickInstall,
        quickStartHooks,
        interOnlineExp,
        interMLProject,
        interProducts,
        interSupport,
        interPower,
        interImpact
    }
};

export default useIndex;